import { MaskedTextBox, MaskedTextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { SyntheticEvent, useState } from "react";
import { GridFilterCellProps } from "@progress/kendo-react-grid";

export const DefaultLoadingTimeFilterCell = ({ onChange }: GridFilterCellProps) => {
  const [filterCellValue, setFilterCellValue] = useState<string>("");
  const [isFilterActive, setIsFilterActive] = useState<boolean>(false);

  const timeFormatWithLeadingZero = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

  const resetGridFilter = (event: SyntheticEvent<unknown, Event>) => {
    setFilterCellValue("");
    setIsFilterActive(false);
    onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };

  const filterCellMask = "00:00";

  const onChangeValue = (event: MaskedTextBoxChangeEvent) => {
    const { value: filterValue } = event.target;
    setFilterCellValue(filterValue);
    setIsFilterActive(true);

    if (filterValue === filterCellMask.replace(/[0-9]/g, "_")) {
      resetGridFilter(event.syntheticEvent);
    }

    if (filterValue.match(timeFormatWithLeadingZero)) {
      onChange({
        value: filterValue,
        operator: filterValue ? "eq" : "",
        syntheticEvent: event.syntheticEvent,
      });
    }
  };

  return (
    <div className="k-filtercell">
      <MaskedTextBox
        width={200}
        mask={filterCellMask}
        onChange={onChangeValue}
        value={filterCellValue}
      />
      <Button title="Clear" onClick={resetGridFilter} disabled={!isFilterActive}>
        <span
          className={`k-icon k-i-filter-clear k-button-icon ${
            !isFilterActive ? "k-disabled" : "k-clear-button-visible"
          }`}
        />
      </Button>
    </div>
  );
};
